// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body, html {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

  font-size: 12px;
  color: #444;

  height: 100%;
  padding: 0;
  margin: 0;
}

h1, h2, h3, h4 {
  font-weight: normal;
}

h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}

ul {
  padding-left: 30px;
}

ol {
  padding-left: 30px;
}
`, "",{"version":3,"sources":["webpack://./client/css/normalize.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;;EAE3D,eAAe;EACf,WAAW;;EAEX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody, html {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  font-size: 12px;\n  color: #444;\n\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\nh1, h2, h3, h4 {\n  font-weight: normal;\n}\n\nh2 {\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\nul {\n  padding-left: 30px;\n}\n\nol {\n  padding-left: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
